import  ApiService  from '../../services/api.service'
import { TokenService } from '../../services/storage.service';
import HashMake from '../../services/hash.service'

const state = {
    // registerSuccess: false,
    // registerErrorCode: 0,
    // registerError: [],
    loading: false,
    isShow: false,
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    
}

const getters = {  
    isShow: (state) => state.isShow,
    response: (state) => state.response,
    loading: state => state.loading,
}

const actions = {
    setIsShow({ commit }, value) {
        commit('setIsShow', value)
    },
    async storeData({ commit, dispatch }, data) {
        commit('setLoading', true)

        return new Promise((resolve, reject) => {
            ApiService.post('register', data)
                .then(response => {
                    commit('setResponse', response.data)
                    
                    // const response = await ApiService.customRequest(requestData);

                    response.data.access_token = response.data.refresh_token = response.data.token; //remove after testing 
                    
                    localStorage.setItem('userDetails', HashMake.encrypt(response.data.userDetails));
                    localStorage.setItem('userDetailsAddress', HashMake.encrypt(response.data.userAddress));
                    

                    TokenService.saveToken(response.data.access_token);
                    TokenService.saveRefreshToken(response.data.refresh_token);
                    ApiService.setHeader();

                    resolve();
                })
                .catch(error => {
                    commit('setResponse', error.response.data)
                    reject(error);
                })
                .finally(() => {
                    commit('setIsShow', true)
                    commit('setLoading', false)
                })
            });
    },
}

const mutations = {
    
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setResponse(state, data) {
        
        state.response.message = data.message;
        if(data.success == true) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}